function importAll(r) {
  r.keys().forEach(r);
}

// import all js files under src/Widgets/
importAll(require.context("./", true, /(?<!\.test)\.js$/));
// import all ts/tsx files under src/Widgets/
importAll(require.context("./", true, /(?<!\.test)\.(ts|tsx)$/));
